export const newsItems = [
  {
    id: 1,
    date: '13 Nov 2025',
    tag: 'Milestone',
    title: 'DPDP Rules, 2025 notified by MeitY',
    summary: 'The Ministry of Electronics and Information Technology notified the Digital Personal Data Protection Rules, 2025 — 23 rules and 7 schedules operationalising the DPDPA, 2023. The Data Protection Board of India was simultaneously constituted.',
  },
  {
    id: 2,
    date: '20 Nov 2025',
    tag: 'Board',
    title: 'Data Protection Board of India begins receiving breach intimations',
    summary: "With Rule 7's 72-hour breach notification workflow now in force, the Board's digital-first complaints and intimation portal went live for Data Fiduciaries and Data Principals nationwide.",
  },
  {
    id: 3,
    date: '08 Dec 2025',
    tag: 'Industry',
    title: 'Industry bodies publish DPDPA readiness surveys',
    summary: 'Early industry surveys following the Rules notification indicated a majority of mid-sized Indian businesses had not yet completed a data-mapping exercise — underscoring the scale of the 18-month compliance runway.',
  },
  {
    id: 4,
    date: '15 Jan 2026',
    tag: 'Guidance',
    title: 'MeitY explanatory note clarifies Consent Manager registration criteria',
    summary: "MeitY's explanatory note to the DPDP Rules provided further detail on the First Schedule's net-worth, technical capability and interoperability thresholds for entities seeking Consent Manager registration ahead of the November 2026 window.",
  },
  {
    id: 5,
    date: '03 Feb 2026',
    tag: 'Sector',
    title: 'Fintech and healthtech flagged as likely Significant Data Fiduciary categories',
    summary: 'Policy commentary continues to point to large-scale consumer fintech, healthtech and social platforms as probable candidates once the Central Government formally notifies Significant Data Fiduciary thresholds under Section 10.',
  },
  {
    id: 6,
    date: '19 Mar 2026',
    tag: 'Children',
    title: 'Ed-tech platforms pilot verifiable parental consent flows',
    summary: 'Several education-technology platforms began piloting DigiLocker-linked, identity-verified parental consent journeys ahead of Section 9 and Rule 10 enforcement, setting an early implementation pattern for the sector.',
  },
  {
    id: 7,
    date: '02 May 2026',
    tag: 'Compliance',
    title: 'Halfway to the deadline: 12 months to 13 May 2027',
    summary: 'With one year remaining on the compliance runway, compliance advisories across the industry shifted focus from awareness-building to audit-readiness — RoPA completion, breach drills and SDF self-assessment.',
  },
  {
    id: 8,
    date: '25 Jun 2026',
    tag: 'Training',
    title: 'Demand surges for trained DPOs and DPDPA consultants',
    summary: 'Recruitment data cited across compliance circles pointed to a sharp rise in demand for Data Protection Officers and DPDPA implementation consultants as organisations move from planning to execution.',
  },
];
